import React from 'react'
import { Link } from 'react-router-dom'

function Navbar() {
  return (
    <nav className=' w-full h-[5vh] flex flew-row px-6 py-3  bg-[#fdfcf1]'>
        <Link to="/" className='flex justify-center items-center '>
            <div className='font-bold font-nunito text-xl text-rosemadder'>RecipeNook</div>
        </Link>
    </nav>
  )
}

export default Navbar